import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input']
  static values = {
    step: { type: Number, default: 1 }
  }

  apply (event) {
    const min = event.target?.dataset?.boundMin
    const max = event.target?.dataset?.boundMax
    if (min == null || max == null) return

    this.inputTargets.forEach((input) => {
      input.min = min
      input.max = max
      const low = Number(min)
      const high = Number(max)
      const current = Number(input.value)
      if (Number.isFinite(current) && current >= low && current <= high) return

      const basis = Number.isFinite(current) ? current : low
      const bounded = Math.min(high, Math.max(low, basis))
      const snapped = Math.round(bounded / this.stepValue) * this.stepValue
      const next = Math.min(high, Math.max(low, snapped))
      if (Number(input.value) === next) return

      input.value = String(next)
      input.dispatchEvent(new Event('input', { bubbles: true }))
    })
  }
}
